export const MASTER_ICON_COLOR = 'var(--icon-primary-color)';
export const LISTING_DRAFT_COLOR = '#D28853';
export const LISTING_PUBLISHED_COLOR = '#98EA8B';

export const getListingIconColor = (isDraft) => (
  isDraft ? LISTING_DRAFT_COLOR : LISTING_PUBLISHED_COLOR
);
